export const isPCContent = {
    data(){
        return {
            isPC: true
        }
    },
    watch: {
        '$store.state.one.isPC': function (now, old) {// 监听vuex
            this.isPC = now
        }
    },
    mounted(){
        this.isPC = this.$store.state.one.isPC
    }
}


// WEBPACK FOOTER //
// ./src/mixins/isPCContent.js